import $apiPublic from '@/api/apiPublic';
import $apiPrivate from '@/api/apiPrivate';

const getCountries = async () => {
  const response = await $apiPublic.get('countries');
  return response;
};

const getLanguages = async () => {
  const response = await $apiPublic.get('languages');
  return response;
};

const getTranslation = async data => {
  const response = await $apiPublic.post('translations', data);
  return response;
};

const setLanguage = async data => {
  const response = await $apiPrivate.post('clients/change_language', data);
  return response;
};

export default {
  getCountries,
  getLanguages,
  getTranslation,
  setLanguage,
};
